export const ArticlePageTranslations = {
  articlePageTranslations: {
    likeThisArticle: '¿Te gusta este artículo? Compártelo en tus redes',
    moreFromCollection: 'Más de esta colección',
    moreFromSeries: 'Más de esta serie',
    copiedToClipboard: 'Copiado al portapapeles!',
  },
};
